export async function apiRequest(path, options = {}) {
    const token = sessionStorage.getItem("token");
    const isFormData = typeof FormData !== "undefined" && options.body instanceof FormData;
    const headers = {
        ...(isFormData ? {} : { "Content-Type": "application/json" }),
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
        ...(options.headers || {}),
    };

    const response = await fetch(`${process.env.REACT_APP_API_URL}${path}`, {
        ...options,
        headers,
    });

    const refreshedToken = response.headers.get("x-auth-token");
    if (refreshedToken) sessionStorage.setItem("token", refreshedToken);

    if (response.status === 401) {
        throw new Error("SESSION_EXPIRED");
    }

    let json = null;
    const text = await response.text();
    if (text) {
        try {
            json = JSON.parse(text);
        } catch {
            json = text;
        }
    }

    if (!response.ok) {
        console.error(`API request failed: ${response.status} ${response.statusText}`, json);
        const message = (json && json.message) || response.statusText || "Request failed";
        throw new Error(message);
    }

    return json;
}

export async function apiBasicRequest(path, options = {}) {
    const token = sessionStorage.getItem("token");
    const isFormData = typeof FormData !== "undefined" && options.body instanceof FormData;
    const headers = {
        ...(isFormData ? {} : { "Content-Type": "application/json" }),
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
        ...(options.headers || {}),
    };

    const response = await fetch(`${process.env.REACT_APP_API_URL}${path}`, {
        ...options,
        headers,
    });

    const refreshedToken = response.headers.get("x-auth-token");
    if (refreshedToken) sessionStorage.setItem("token", refreshedToken);

    if (response.status === 401) {
        throw new Error("SESSION_EXPIRED"); 
    }

    return response;
}
